// extracted by mini-css-extract-plugin
module.exports = {"label":"payload-email_label__1S_B-","container":"payload-email_container__25NKD"};